<template lang="html">
  <div>
    <div v-if="user_doc.loaded" class="alert alert-secondary">
      <!-- Details of plan go here.-->
      <h3 class="mb-3">Soundslides 3 - {{ user_plan.name }} membership</h3>
      <div v-if="user_doc.subscribed_via_groups">
        <div v-for="group in user_doc.groups" :key="group.key">
          <hr />
          <h5 class="mb-3">You are currently a member of a group plan</h5>
          <p>
            <b>Group name:</b>
            {{ group.all_visible_plan_description }}
          </p>
          <p>
            <b>Plan level:</b> {{ planNameFromId(group.plan_level) }}
            <v-icon
              v-if="group.plan_level == user_plan.plan_id"
              name="check-circle"
              class="ml-1"
              style="color: green"
            />
          </p>
          <p>{{ group.user_visible_note }}</p>
        </div>
      </div>
      <StripeDetails v-if="user_doc.subscribed_via_stripe" />
      <PayPalDetails v-if="user_doc.subscribed_via_paypal" />

      <div v-if="user_plan.plan_id == 'trial'">
        <p v-if="$store.state.validTrialPeriod">
          Your trial membership is valid through
          {{ user_doc.trial_expires_at | date_string }}.
        </p>
        <p v-else>
          Your trial membership expired on
          {{ user_doc.trial_expires_at | date_string }}.
        </p>
      </div>
    </div>

    <div v-if="user_plan_id && user_plan_id != 'premium_annual'">
      <p class="alert alert-success">
        Get more shows and options when you
        <b-link :to="{ name: 'upgrade_view' }">
          upgrade to a {{ next_plan }}
        </b-link>
        account.
      </p>
    </div>

    <div>
      <h4 class="">Email preferences</h4>
      <p v-show="receiveEmailList">
        You are signed up to receive our occasional newsletter.
        <b-link
          variant="outline-secondary"
          size="sm"
          @click="updateNewsletter(false)"
        >
          Opt-out.
        </b-link>
      </p>
      <p v-show="!receiveEmailList">
        You are not signed up to receive our occasional newsletter.
        <b-btn variant="primary" size="sm" @click="updateNewsletter(true)">
          Click to receive email newsletters
        </b-btn>
      </p>
    </div>
    <div class="mt-4">
      <h4>Account information</h4>
      <p>
        <b-link :to="{ name: 'account-update' }">Update email address</b-link>
      </p>
      <h4 class="mt-4">Closing my account</h4>
      <p>
        Closing your account takes effect immediately — your account will be
        inaccessible.
      </p>
      <p>
        For security's sake, the data from your closed account will be
        permanently deleted after 30 days. If you need to get back into your
        account before then for any reason, shoot us an email. We can help!
      </p>
      <p>
        <b-btn size="sm" variant="danger" @click="confirmCloseAccount">
          Close my account
        </b-btn>
      </p>
      <hr class="mt-4" />
      <h5 class="mt-4 mb-3">Beta testing program</h5>
      <p>
        From time to time, we release new features early to users who opt-in to
        our beta testing program.
      </p>
      <p>
        If you opt-in, you will see additional notes in the application when new
        features are available.
      </p>
      <p class="alert alert-info">
        While most beta features will eventually be released to all accounts,
        some advanced features may only be released as part of higher-tier
        subscription plans. During the beta period, all beta features are
        available for all accounts, even trial accounts. Beta features are
        experimental and may change at any time.
      </p>
      <div v-if="!user_doc.beta_tester">
        <p>
          <b-btn size="sm" variant="secondary" @click="toggleBeta">
            Add me to the beta testing group
          </b-btn>
        </p>
      </div>
      <div v-if="user_doc.beta_tester">
        <p>
          <span class="mark p-2">
            You are enrolled in our beta testing program.
          </span>
        </p>
        <p>
          <b-btn size="sm" variant="secondary" @click="toggleBeta">
            Remove me from the beta testing group
          </b-btn>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { format, addYears } from "date-fns";
import StripeDetails from "@/components/StripeDetails.vue";
import PayPalDetails from "@/components/PayPalDetails.vue";
import { plans } from "@/defaults";
import find from "lodash/find";
export default {
  name: "AccountDetails",
  components: {
    StripeDetails,
    PayPalDetails
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    add_one_year: function(value) {
      return format(
        addYears(new Date(value * 1000), 1),
        "MMMM d, yyyy h:mm aa"
      );
    },
    date_string: function(value) {
      return format(new Date(value), "MMMM d, yyyy h:mm aa");
    },
    date_string_short: function(value) {
      return format(new Date(value), "MMMM d, yyyy");
    }
  },
  computed: {
    user_doc() {
      return this.$store.state.user_doc;
    },
    user_plan() {
      return this.$store.getters.user_plan;
    },
    receiveEmailList() {
      if ("emailListSubscribed" in this.user_doc) {
        return this.user_doc.emailListSubscribed;
      }
      return true;
    },
    user_plan_id() {
      if (!this.user_plan) {
        return null;
      }
      return this.user_plan.plan_id;
    },
    next_plan() {
      if (!this.user_plan) {
        return "Standard";
      }
      if (this.user_plan.plan_id === "plus_annual") {
        return "Premium";
      }
      if (this.user_plan.plan_id === "standard_annual") {
        return "Plus";
      }
      if (this.user_plan.plan_id === "plus_monthly") {
        return "Premium";
      }
      if (this.user_plan.plan_id === "standard_monthly") {
        return "Plus";
      }
      return "Standard";
    }
  },
  methods: {
    planNameFromId(plan_id) {
      return find(plans, { plan_id: plan_id }).name;
    },
    pretty: function(obj) {
      return JSON.stringify(obj, undefined, 2);
    },
    updateNewsletter(statusBoolean) {
      this.$store.dispatch("update_newsletter", statusBoolean);
    },
    toggleBeta() {
      var is_beta_tester = this.user_doc.beta_tester == true;
      this.$store.dispatch("updateBetaTesterProperty", !is_beta_tester);
    },
    confirmCloseAccount() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to close your account and delete all of your data.",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Yes, close my account",
            cancelTitle: "Cancel",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.$store.dispatch("markAccountClosed");
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err);
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
